import { render, staticRenderFns } from "./StockOrderReport.vue?vue&type=template&id=273ff816&scoped=true"
import script from "./StockOrderReport.vue?vue&type=script&lang=js"
export * from "./StockOrderReport.vue?vue&type=script&lang=js"
import style1 from "./StockOrderReport.vue?vue&type=style&index=1&id=273ff816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273ff816",
  null
  
)

export default component.exports